import { useEffect, useState } from "react";
import { getUsableFolder } from "../../utils/inDesignServices";

function FolderSetting() {
  const [usableFolder, setUsableFolder] = useState(null);
  const _getUsableFolder = async () => {
    let folder = await getUsableFolder();
    console.log("fff",folder)
    if (!folder.includes("Error")) {
      setUsableFolder(folder.replace(/\\\\/g, "/"));
    }
  };
  useEffect(() => {
    _getUsableFolder();
  }, []);
  return (
    <fieldset className="mg-b15">
      <legend>Folder Settings</legend>
      <div className="d-flex available-field">
        <span>Export Folder </span>
        <input
          value={usableFolder}
          contentEditable={!usableFolder}
          className="form-control ng-untouched ng-pristine ng-valid"
          placeholder="Desktop/Indesign-Connector/"
          type="text"
        />
      </div>
    </fieldset>
  );
}

export default FolderSetting;
